import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { UtensilsIcon, SparklesIcon, CalendarIcon, DumbbellIcon, WindIcon, BookOpenIcon, ShoppingCartIcon, ClipboardCheckIcon } from 'lucide-react';
const features = [{
  icon: UtensilsIcon,
  title: 'El Plato Fácil',
  desc: 'Fórmula práctica para armar cada comida sin contar calorías ni porciones complejas.'
}, {
  icon: SparklesIcon,
  title: '7 Hábitos de Alto Impacto',
  desc: 'Desde la hidratación hasta la cena ligera, lo que de verdad marca la diferencia.'
}, {
  icon: CalendarIcon,
  title: 'Plan de 14 Días',
  desc: 'Una acción diaria clara, paso a paso, para crear inercia positiva.'
}, {
  icon: DumbbellIcon,
  title: 'Rutinas de Movimiento',
  desc: 'Ejercicios de fuerza básica y movilidad suave, adaptados para principiantes.'
}, {
  icon: WindIcon,
  title: 'Herramientas de Estrés y Sueño',
  desc: 'Respiración guiada, pausas de 60 segundos y ritual nocturno para descansar mejor.'
}, {
  icon: BookOpenIcon,
  title: 'Menú Ejemplo de 3 Días',
  desc: 'Ideas de desayuno, comida y cena para inspirarse.'
}, {
  icon: ShoppingCartIcon,
  title: 'Lista de Compras',
  desc: 'Ingredientes fáciles de conseguir (opciones para LatAm y USA).'
}, {
  icon: ClipboardCheckIcon,
  title: 'Hoja de Seguimiento',
  desc: 'Para monitorear su energía, sueño y progreso diario.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function IncludedSection() {
  return <section className="py-24 px-6 md:px-12 bg-cream-50 w-full flex justify-center" data-id="element-80">
      <div className="max-w-6xl w-full" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-playfair text-bark-900 mb-4" data-id="element-83">
            ¿Qué incluye su compra?
          </h2>
          <div className="w-24 h-1 bg-sage-300 mx-auto rounded-full" data-id="element-84"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-85">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-xl shadow-sm border border-cream-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col h-full group" data-id="element-86">
              <div className="w-12 h-12 rounded-lg bg-sage-50 flex items-center justify-center mb-6 group-hover:bg-sage-100 transition-colors duration-300" data-id="element-87">
                <feature.icon className="w-6 h-6 text-sage-600" data-id="element-88" />
              </div>
              <h3 className="text-xl font-playfair font-semibold text-bark-900 mb-3" data-id="element-89">
                {feature.title}
              </h3>
              <p className="text-bark-700 font-lato text-sm leading-relaxed flex-grow" data-id="element-90">
                {feature.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}